<template>
  <a-layout class="my-application-box">
    <a-card class="create-application" :bordered=false :class="fromLocation==='msg'?'msg-create-application':''">
      <div slot="title" v-if="pageLayout.pageTitle">
        <a-icon v-if="fromLocation==='app'" style="cursor:pointer;" type="left-circle" @click="back" />
        <div>{{pageLayout.pageTitle}}</div>
        <span class="page-status " :class="{'page-status-yellow':params.status==='审批中','page-status-green':params.status==='审批通过'||params.status==='付款成功','page-status-red':params.status==='审批拒绝'||params.status==='付款失败','page-status-gray':params.status==='已撤回'}">{{params.status}}</span>
      </div>
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="loadedLayout && loadedInfo">
        <common-form :ref="'commonForm'" :layout="layout" v-if="layout.type==='commonForm'" :params="layout.field && params[layout.field]?params[layout.field]:{}" :can-edit="canEdit" :need-id="true" @changed-fields="onFieldChange"></common-form>
        <multi-form :ref="'multiForm'" :layout="layout" v-if="layout.type==='multiForm'" :params="layout.field && params[layout.field]?params[layout.field]:[]" :can-edit="canEdit" :need-id="true" @changed-fields="onFieldChange"></multi-form>
        <summation :layout="layout" v-if="layout.type==='summation'" :params="params[layout.field]?params[layout.field]:{}" :all-params="paramsBackup"></summation>
        <upload v-if="layout.type==='upload'" :layout="layout" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit"></upload>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'审批流数据加载中...'" v-if="loadedLayout && loadedInfo"></approval-flow>
      <a-row v-if="params.process_status && loadedInfo && loadedLayout" style="margin-top:20px;" :class="fromLocation==='msg'?'msg-submit-box':''">
        <a-textarea v-if="fromLocation==='msg'" class="msg-textarea" placeholder="请输入审批意见" v-model="comment"></a-textarea>
        <a-col :xs="24" :sm="4"></a-col>
        <a-col :xs="24" :sm="20" :style="fromLocation==='msg'?'text-align:right':''">
          <a-button :disabled="disabledSubmit" type="primary" @click="approval(1)" style="width:120px;margin-right:18px;">批准</a-button>
          <a-button :disabled="disabledSubmit" @click="approval(0)" style="width:120px;margin-right:18px;">退回</a-button>
          <!-- <a-button :disabled="disabledSubmit" @click="visibleComment = true" style="width:120px;">评论</a-button> -->
        </a-col>
      </a-row>
      <div style="text-align:center" v-if="!loadedInfo || !loadedLayout">
        <a-spin tip="数据加载中..."></a-spin>
      </div>
    </a-card>
    <form-modal :basic-modal="approvalModal" :form-layout="approvalInfolModal" :confirm-loading="confirmLoading" @submit="approvalModalSubmit" @cancel="approvalModalCancel"></form-modal>
    <comment-and-copy :visible="visibleComment" @cancel="visibleComment = false" @reload="reload"></comment-and-copy>
  </a-layout>
</template>

<script>
import UUID from "uuidjs";
import SvgIcBackbtn from "../../assets/svg/ic-left-circle-o.svg";
import SvgIcFile from "../../assets/svg/ic-file-o.svg";
import SvgIcEdit from "../../assets/svg/ic-edit-o.svg";
import SvgIcCopy from "../../assets/svg/ic-copy-o.svg";
import SvgIcEnter from "../../assets/svg/ic-enter.svg";
import CommonForm from "../../components/CommonForm.vue";
import MultiForm from "../../components/MultiForm.vue";
import Summation from "../../components/Summation.vue";
import ApprovalFlow from "../../components/ApprovalFlow.vue";
import FormModal from "../../components/FormModal.vue";
import Upload from "../../components/Upload.vue";
import { setTimeout } from "timers";
import LayoutConfig from "../../utils/LayoutConfig.js";
import { layoutConfig } from "../../utils/mockData.js";
import {
  backInfoFormModal,
  agreeInfoFormModal
} from "../../data/formModalConfigs.js";

import {
  getPurchaseLayout,
  getPurchaseDetailInfo,
  getPurchaseDetailFlow,
  approvalPurchaseApplication,
  passPurchaseApi,
  rejectPurchaseApi
} from "../../services/CommonService.js";
import { modifyPaymentInfo } from "../../services/MyApplicationListService.js";

export default {
  components: {
    SvgIcBackbtn,
    SvgIcFile,
    SvgIcEdit,
    SvgIcCopy,
    SvgIcEnter,
    CommonForm,
    MultiForm,
    Summation,
    ApprovalFlow,
    FormModal,
    Upload
  },
  data() {
    return {
      canEdit: false,
      retreatModalVisible: false,
      breadcrumb: [
        {
          label: "待我审批",
          path: ""
        }
      ],
      cardHeight: 0,
      applicationTitle: "待我审批详情",
      params: {},
      paramsBackup: {},
      loadedLayout: false,
      loadedInfo: false,
      pageLayout: {},
      approvalFlowInfo: [],
      fromLocation: undefined,
      approvalModal: {
        visible: false,
        title: "打回",
        contentTitle: "你确定拒绝报销申请吗?",
        width: 560,
        formItemLayout: {
          layout: "vertical",
          labelCol: {
            xs: { span: 24 },
            sm: { span: 24 }
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 }
          }
        }
      },
      approvalInfolModal: [],
      confirmLoading: false,
      requestParams: {},
      comment: undefined,
      disabledSubmit: false,
      visibleComment: false
    };
  },

  created() {
    this.fromLocation =
      window.location.href.indexOf("fromLocation=msg") === -1 ? "app" : "msg";
    this.id = this.$route.query.id;
    Promise.all([this.fetchDetailInfo()]).then(() => {
      this.fetchLayout();
    });
    this.fetchApprovalFlow();
  },
  mounted() {},

  computed: {},

  methods: {
    compareObj(aobj, bobj) {
      if (_.isObject(aobj) && !_.isArray(aobj)) {
        Object.keys(aobj).forEach(key => {
          if (_.isObject(aobj[key]) && _.isObject(bobj[key])) {
            this.compareObj(aobj[key], bobj[key]);
          } else {
            bobj[key] = aobj[key];
          }
        });
      } else if (_.isArray(aobj)) {
        aobj.forEach((item, index) => {
          this.compareObj(aobj[index], bobj[index]);
        });
      }
      return bobj;
    },
    fetchLayout() {
      this.loadedLayout = false;
      getPurchaseLayout({
        type: "detail",
        id: this.$route.query.id,
        menu_type: 2
      }).then(res => {
        if (res.status === "success") {
          this.pageLayout = res.data;
          this.loadedLayout = true;
        } else {
          this.$Message.error(res.message);
          this.loadedLayout = true;
        }
      });
    },
    fetchDetailInfo() {
      this.loadedInfo = false;
      return getPurchaseDetailInfo({
        id: this.$route.query.id,
        menu_type: 2
      }).then(res => {
        if (res.status === "success") {
          this.params = Object.assign({}, this.params, res.data);
          this.paramsBackup = _.cloneDeep(this.params);
          this.loadedInfo = true;
        } else {
          this.$Message.error(res.message);
          this.loadedInfo = true;
        }
      });
    },
    fetchApprovalFlow() {
      getPurchaseDetailFlow({ id: this.$route.query.id }).then(res => {
        if (res.status === "success") {
          res.data.forEach((item, index) => {
            this.$set(this.approvalFlowInfo, index, item);
          });
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    onFieldChange(e) {
      this.params = Object.assign({}, this.params, e);
      this.requestParams = _.cloneDeep(this.params);
      this.compareObj(this.params, this.paramsBackup);
    },
    back() {
      this.$router.replace({
        name: "waitApprovalList",
        query: {
          apply_type: 7
        }
      });
    },
    approval(e) {
      let validateResult = true;
      if (e) {
        this.$refs.commonForm.forEach(item => {
          if (!item.validateFields()) {
            validateResult = false;
          }
        });
        this.$refs.multiForm.forEach(item => {
          if (!item.validateFields()) {
            validateResult = false;
          }
        });
      }
      if (!validateResult) {
        return;
      }
      if (this.fromLocation === "msg") {
        let params = {
          apply_id: this.$route.query.id,
          comment: this.comment
        };
        if (!e && !this.comment) {
          this.$Message.warn("拒绝理由必填");
          return;
        }
        if (e && this.requestParams) {
          params = { ...this.requestParams, ...params };
        }
        const url = e ? passPurchaseApi : rejectPurchaseApi;
        this.disabledSubmit = true;
        approvalPurchaseApplication(url, params).then(res => {
          if (res.status === "success") {
            this.$Message.success("审批成功");
            location.reload();
          } else {
            this.$Message.error(res.message);
          }
          this.disabledSubmit = false;
        });
      } else {
        this.approvalModal.visible = true;
        if (e) {
          this.approvalInfolModal = agreeInfoFormModal;
          this.approvalModal.title = "同意";
          this.approvalModal.contentTitle = "你确定同意此采购申请吗";
          this.approvalStatus = 2;
        } else {
          this.approvalInfolModal = backInfoFormModal;
          this.approvalModal.title = "拒绝";
          this.approvalModal.contentTitle = "你确定拒绝此采购申请吗";
          this.approvalStatus = 3;
        }
      }
    },
    approvalModalSubmit(e) {
      let params = {
        apply_id: this.$route.query.id,
        comment: e.reason
      };
      if (this.approvalStatus === 2 && this.requestParams) {
        params = { ...this.requestParams, ...params };
      }
      this.confirmLoading = true;
      const url =
        this.approvalStatus === 3 ? rejectPurchaseApi : passPurchaseApi;
      approvalPurchaseApplication(url, params).then(res => {
        if (res.status === "success") {
          this.approvalModal.visible = false;
          this.$Message.success("审批成功");
          this.back();
        } else {
          this.$Message.error(res.message);
        }
        this.confirmLoading = false;
      });
    },
    approvalModalCancel() {
      this.approvalModal.visible = false;
    },
    close() {
      dd.biz.navigation.quit();
    },

    reload() {
      this.visibleComment = false;
      this.fetchApprovalFlow();
    }
  }
};
</script>

<style lang="less">
.my-application-box {
  padding: 16px;
}
</style>
